import { defineStore } from "pinia";

import * as R from "ramda";
import axios from "../../axios-auth";

export const useActiveOptionStore = defineStore("activeOption", {
  state: () => ({
    activePageOptionCode: ""
  }),

  getters: {
    getActivePageOption: state => {
      return state.activePageOptionCode;
    }
  },

  actions: {
    setActivePageOptionCode(payload) {
      this.activePageOptionCode = payload;
    }
  }
});
